import React from "react";
import Select from "react-select";
import fieldStyles from "./Select.module.scss";

const SelectCustom = (props) => {
  const {
    isMulti = false,
    optionsHeight,
    options,
    searchable = false,
    placeholder = "",
    value,
    styles,
    isDisplay,
    data,
    ...rest
  } = props;

  const customStyles = {
    control: (provided) => ({
      ...provided,
      background: "none",
      border: "none",
      minHeight: "12px",
      height: isMulti ? "max-content" : "28px",
      boxShadow: "none",
      overflow: isMulti ? "auto" : "hidden",
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: isMulti ? "max-content" : "24px",
      padding: "0 8px",
      maxHeight: "50px",
      overflowX: "auto",
      flexWrap: "nowrap",
      scrollbarWidth: "none",
    }),
    menuList: (provided) => ({
      ...provided,
      minHeight: optionsHeight || "40px",
      overflowY: "auto",
    }),
    option: (provided) => ({
      ...provided,
      cursor: "pointer",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0px",
      padding: "0",
      fontWeight: "600",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: isMulti ? "max-content" : "28px",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    placeholder: (provided) => ({
      ...provided,
      color: "#aeb2e3",
      fontSize: "0.9rem",
      // Your desired placeholder color
      // fontWeight: "500",
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      whiteSpace: "normal",
      overflow: "visible",
      textOverflow: "initial",
      maxWidth: "none",
    }),
    multiValue: (styles) => ({
      ...styles,
      maxWidth: "100%",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      padding: "0px",
    }),
  };

  return (
    <>
      <Select
        {...rest}
        value={value}
        options={options || []}
        menuPortalTarget={document.body}
        menuPosition="absolute"
        placeholder={placeholder}
        maxMenuHeight={125}
        isSearchable={searchable}
        styles={{ ...customStyles, ...styles }}
        className="basic-single"
        classNamePrefix="select"
        isMulti={isMulti}
        isDisplay={isDisplay}
      />
      {isDisplay && Array.isArray(data.value) && data.value.length > 0 && (
        <div className={fieldStyles.skillsInputWrapper}>
          <div className={fieldStyles.inputWithTags}>
            {data.value.map((item, index) => (
              <div
                key={index}
                onClick={() => {
                  const updated = data.value.filter((_, i) => i !== index);
                  data.onChange(updated);
                }}
                className={fieldStyles.skillCard}
              >
                <p className={fieldStyles.skillsText}>{item.label}</p>
                <button type="button" className={fieldStyles.removeBtn}>
                  ✕
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
{/*        
      {error && <span className={styles.errorText}>{error.message}</span>}   */}
    </>
  );
};

export default SelectCustom;
